import type { EntityID } from "./types";

export type * from "./types";

export const DEFAULT_ENTITY_ID: EntityID = "entity0";
